import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./navbar.module.css";
import classNames from "classnames";
import logo from "assets/images/smallLogo.png";
import { matchRoutes, useLocation } from "react-router-dom";
import commonStyles from "shared/utils/common.module.css";
import { FaBars } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { FaAngleDown } from "react-icons/fa";

import {
  setHomeServiceSelectedRoute,
  setMedicalSelectedRoute,
  setTravelSelectedRoute,
  setmainSelectedRoute,
} from "shared/redux";
import LoadingModal from "../LoaderModal";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  // const [selectedOption, setSelectedOption] = useState("/");
  const location = useLocation();
  const dispatch = useDispatch();
  const { mainSelectedRoute } = useSelector((state: any) => state.root.common);
  const setSelectedOption = (route: any) => {
    dispatch(setmainSelectedRoute(route));
    dispatch(setMedicalSelectedRoute("doctor/login"));
    dispatch(setHomeServiceSelectedRoute("ambulance/login"));
    dispatch(setTravelSelectedRoute("hotel/login"));
  };
  const [isDropdownVisible1, setIsDropdownVisible1] = useState(false);
  const [isDropdownVisible2, setIsDropdownVisible2] = useState(false);
  const [isDropdownVisible3, setIsDropdownVisible3] = useState(false);

  // Function to toggle the visibility of each dropdown
  const toggleDropdown1 = () => {
    setIsDropdownVisible1(!isDropdownVisible1);
    setIsDropdownVisible2(false);
    setIsDropdownVisible3(false);
  };

  const toggleDropdown2 = () => {
    setIsDropdownVisible2(!isDropdownVisible2);
    setIsDropdownVisible1(false);
    setIsDropdownVisible3(false);
  };

  const toggleDropdown3 = () => {
    setIsDropdownVisible3(!isDropdownVisible3);
    setIsDropdownVisible1(false);
    setIsDropdownVisible2(false);
  };

  // const handleLoading = () => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 3000);
  // };
  return (
    <div
      className={classNames(
        styles.navbar,
        styles.shadow,
        location.pathname !== "/" && styles.shadow,
        {
          [styles.home]: location.pathname === "/",
          [styles.laboratory2]: location.pathname === "/laboratory/login",
          [styles.laboratory]: location.pathname === "/laboratory/signup",
          [styles.pharmcy]: location.pathname === "/pharmacy/login",
          [styles.pharmcy2]: location.pathname === "/pharmacy/signup",
          [styles.doctor]:
            mainSelectedRoute === "/medicalservices/doctor/login",
          [styles.doctor2]:
            location.pathname === "/medicalservices/doctor/signup",
          [styles.Hospital2]:
            location.pathname === "/medicalservices/hospital/login",

          [styles.Hospital]:
            location.pathname === "/medicalservices/hospital/signup",
          [styles.ambulanceservices]: mainSelectedRoute === "/ambulance/login",

          [styles.ambulanceservices2]: location.pathname === "/ambulance/login",
          [styles.ambulanceservices]:
            location.pathname === "/homeservices/ambulanceservices/signup",

          [styles.Physiothrapist2]:
            location.pathname === "/homeservices/physiotherapist/login",
          [styles.Physiothrapist]:
            location.pathname === "/homeservices/physiotherapist/signup",

          [styles.nutritionist2]:
            location.pathname === "/homeservices/nutritionist/login",
          [styles.nutritionist]:
            location.pathname === "/homeservices/nutritionist/signup",

          [styles.paramedicstaff2]: location.pathname === "/paramedic/login",
          [styles.paramedicstaff]:
            location.pathname === "/homeservices/paramedicstaff/signup",

          [styles.psychologist2]:
            location.pathname === "/homeservices/psychologist/login",
          [styles.psychologist]:
            location.pathname === "/homeservices/psychologist/signup",

          [styles.hotel2]: location.pathname === "/hotel/login",
          [styles.hotel]: location.pathname === "/traveltourism/hotel/signup",
          [styles.rentAcar2]: location.pathname === "/rentacar/login",
          [styles.rentAcar]:
            location.pathname === "/traveltourism/rentAcar/signup",
          [styles.travelAgency]: location.pathname === "/travelagency/login",
          [styles.travelAgency2]:
            location.pathname === "/traveltourism/travelAgency/signup",

          [styles.donation]: location.pathname === "/donation/signup",
          [styles.donation2]: location.pathname === "/donation/login",
          [styles.insurance2]: location.pathname === "/Insurance/signup",
          [styles.insurance]: location.pathname === "/Insurance/login",

          [styles.laboratoryAgreement]:
            location.pathname === "/laboratoryAgreement",
          [styles.privacyPolicies]: location.pathname === "/privacyPolicies",

          [styles.refundPolicy]: location.pathname === "/refundPolicy",

          [styles.termsofUse]: location.pathname === "/termsofUse",
        }
      )}
    >
      <div className={classNames(styles.container)}>
        <div className={classNames(styles["image-container"])}>
          <img
            src={logo}
            alt="logo"
            className={classNames(styles["responsive-image"])}
          />
        </div>
        <div className={classNames(styles["nav-links"], styles.border)}>
          <li>
            <Link
              className={classNames(
                styles.navvlink,
                commonStyles.semiBold,
                commonStyles.fs14,
                {
                  [styles.selected]: mainSelectedRoute === "/",
                }
              )}
              to="/"
              onClick={() => setSelectedOption("/")}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              className={classNames(
                styles.navvlink,
                commonStyles.semiBold,
                commonStyles.fs14,
                {
                  [styles.selected]: mainSelectedRoute === "/laboratory/login",
                }
              )}
              to="/laboratory/login"
              onClick={() => {
                setSelectedOption("/laboratory/login");
                // handleLoading();
              }}
            >
              Laboratory
            </Link>
          </li>
          <li>
            <Link
              className={classNames(
                styles.navvlink,
                commonStyles.semiBold,
                commonStyles.fs14,
                {
                  [styles.selected]: mainSelectedRoute === "/pharmacy/login",
                }
              )}
              to="/pharmacy/login"
              onClick={() => setSelectedOption("/pharmacy/login")}
            >
              Pharmacy
            </Link>
          </li>
          <li>
            <div onClick={toggleDropdown1} className={commonStyles.flx}>
              <p
                className={classNames(
                  styles.navvlink,
                  commonStyles.semiBold,
                  commonStyles.fs14
                )}
              >
                Medical Services
              </p>
              <FaAngleDown className={styles.downIcon} />
            </div>

            {isDropdownVisible1 && (
              <ul className={styles.dropdownMenu}>
                <li>
                  <Link
                    to="/medicalservices/doctor/login"
                    onClick={() =>
                      setSelectedOption("/medicalservices/doctor/login")
                    }
                  >
                    Doctor
                  </Link>
                </li>
                <li>
                  <Link
                    to="/medicalservices/hospital/login"
                    onClick={() =>
                      setSelectedOption("/medicalservices/hospital/login")
                    }
                  >
                    Hospital
                  </Link>
                </li>
                {/* Add more options as needed */}
              </ul>
            )}
          </li>
          <li>
            <div onClick={toggleDropdown2} className={commonStyles.flx}>
              <p
                className={classNames(
                  styles.navvlink,
                  commonStyles.semiBold,
                  commonStyles.fs14
                )}
              >
                Home Services
              </p>
              <FaAngleDown className={styles.downIcon} />
            </div>

            {isDropdownVisible2 && (
              <ul className={styles.dropdownMenu}>
                <li>
                  <Link
                    to="/ambulance/login"
                    onClick={() => setSelectedOption("/ambulance/login")}
                  >
                    Ambulance
                  </Link>
                </li>
                <li>
                  <Link
                    to="/homeservices/physiotherapist/login"
                    onClick={() =>
                      setSelectedOption("/homeservices/physiotherapist/login")
                    }
                  >
                    Physiotherapist
                  </Link>
                </li>
                <li>
                  <Link
                    to="/homeservices/nutritionist/login"
                    onClick={() =>
                      setSelectedOption("/homeservices/nutritionist/login")
                    }
                  >
                    Nutritionist
                  </Link>
                </li>
                <li>
                  <Link
                    to="/paramedic/login"
                    onClick={() => setSelectedOption("/paramedic/login")}
                  >
                    Paramedic Staff
                  </Link>
                </li>
                <li>
                  <Link
                    to="/homeservices/psychologist/login"
                    onClick={() =>
                      setSelectedOption("/homeservices/psychologist/login")
                    }
                  >
                    Psychologist
                  </Link>
                </li>
                {/* Add more options as needed */}
              </ul>
            )}
          </li>
          <li>
            <div onClick={toggleDropdown3} className={commonStyles.flx}>
              <p
                className={classNames(
                  styles.navvlink,
                  commonStyles.semiBold,
                  commonStyles.fs14
                )}
              >
                Travel & Tourism
              </p>
              <FaAngleDown className={styles.downIcon} />
            </div>

            {isDropdownVisible3 && (
              <ul className={styles.dropdownMenu}>
                <li>
                  <Link
                    to="/hotel/login"
                    onClick={() => setSelectedOption("/hotel/login")}
                  >
                    Hotel
                  </Link>
                </li>
                <li>
                  <Link
                    to="/rentacar/login"
                    onClick={() => setSelectedOption("/rentacar/login")}
                  >
                    Car A Rent
                  </Link>
                </li>
                <li>
                  <Link
                    to="/travelagency/login"
                    onClick={() => setSelectedOption("/travelagency/login")}
                  >
                    Travel Agency
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link
              className={classNames(
                styles.navvlink,
                commonStyles.semiBold,
                commonStyles.fs14,
                {
                  [styles.selected]: mainSelectedRoute === "/donation/login",
                }
              )}
              to="/donation/login"
              onClick={() => setSelectedOption("/donation/login")}
            >
              Donation
            </Link>
          </li>
          <li>
            <Link
              className={classNames(
                styles.navvlink,
                commonStyles.semiBold,
                commonStyles.fs14,
                {
                  [styles.selected]: mainSelectedRoute === "/Insurance/login",
                }
              )}
              to="/Insurance/login"
              onClick={() => setSelectedOption("/Insurance/login")}
            >
              Insurance
            </Link>
          </li>
        </div>
        <div>
          <FaBars
            className={styles.barbtn}
            style={{ color: "black" }}
            onClick={toggleMenu}
          />
        </div>
        {isMenuOpen && (
          <div className={styles.mobileMenu}>
            {/* Add mobile menu items here */}
            <Link
              to="/"
              onClick={() => {
                setSelectedOption("/");
                setIsMenuOpen(false);
              }}
            >
              Home
            </Link>
            <Link
              to="/laboratory/login"
              onClick={() => {
                setSelectedOption("/laboratory/login");
                setIsMenuOpen(false);
              }}
            >
              Laboratory
            </Link>
            <Link
              to="/pharmacy/login"
              onClick={() => {
                setSelectedOption("/pharmacy/login");
                setIsMenuOpen(false);
              }}
            >
              Pharmacy
            </Link>
            <Link
              to="/medicalservices/doctor/login"
              onClick={() => {
                setSelectedOption("/medicalservices/doctor/login");
                setIsMenuOpen(false);
              }}
            >
              Doctor’s
            </Link>
            <Link
              to="/medicalservices/hospital/login"
              onClick={() => {
                setSelectedOption("/medicalservices/hospital/login");
                setIsMenuOpen(false);
              }}
            >
              Hospital
            </Link>
            <Link
              to="/ambulance/login"
              onClick={() => {
                setSelectedOption("/ambulance/login");
                setIsMenuOpen(false);
              }}
            >
              Ambulance Services
            </Link>
            <Link
              to="/homeservices/physiotherapist/login"
              onClick={() => {
                setSelectedOption("/homeservices/physiotherapist/login");
                setIsMenuOpen(false);
              }}
            >
              Physiotherapist
            </Link>
            <Link
              to="/homeservices/nutritionist/login"
              onClick={() => {
                setSelectedOption("/homeservices/nutritionist/login");
                setIsMenuOpen(false);
              }}
            >
              Nutritionist
            </Link>
            <Link
              to="/paramedic/login"
              onClick={() => {
                setSelectedOption("/paramedic/login");
                setIsMenuOpen(false);
              }}
            >
              Paramedic staff
            </Link>
            <Link
              to="/homeservices/psychologist/login"
              onClick={() => {
                setSelectedOption("/homeservices/psychologist/login");
                setIsMenuOpen(false);
              }}
            >
              Psychologist
            </Link>
            <Link
              to="/hotel/login"
              onClick={() => {
                setSelectedOption("/hotel/login");
                setIsMenuOpen(false);
              }}
            >
              Hotel
            </Link>
            <Link
              to="/rentacar/login"
              onClick={() => {
                setSelectedOption("/rentacar/login");
                setIsMenuOpen(false);
              }}
            >
              Rent A Car
            </Link>
            <Link
              to="/travelagency/login"
              onClick={() => {
                setSelectedOption("/travelagency/login");
                setIsMenuOpen(false);
              }}
            >
              Travel Agency
            </Link>
            <Link
              to="/donation/login"
              onClick={() => {
                setSelectedOption("/donation/login");
                setIsMenuOpen(false);
              }}
            >
              Donation
            </Link>
            <Link
              to="/Insurance/login"
              onClick={() => {
                setSelectedOption("/Insurance/login");
                setIsMenuOpen(false);
              }}
            >
              Insurance
            </Link>
          </div>
        )}
      </div>
      {/* {loading && <LoadingModal showModal={loading} />} */}
    </div>
  );
};
export default NavBar;
